export * from './LocaleSettings';
export * from './LocaleSettings.interface';
